import { ToggleButton } from "../StoryPreview";
import PropTypes from "prop-types";
import { MoreItem } from "./MoreButton";
import { Confirm } from "ui";

function OrderButton({ mode, story }) {
  if (!story.isOwner && !story.isPublic) return null;

  return (
    <OrderConfirm story={story}>
      {mode === "menu" ? (
        <MoreItem icon="shopping_cart">Comprar</MoreItem>
      ) : (
        <ToggleButton icon="shopping_cart" label="Comprar" />
      )}
    </OrderConfirm>
  );
}

OrderButton.propTypes = {
  story: PropTypes.shape({
    _id: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    isOwner: PropTypes.bool,
    isPublic: PropTypes.bool,
  }).isRequired,
};

export const OrderConfirm = ({ children, story }) => (
  <Confirm
    title="¿Deseas adquirir este libro impreso?"
    description={`Cotiza el libro «${story.name}» y recíbelo en tu casa. Podrás elegir entre diferentes formatos y opciones de encuadernación.`}
    onConfirm={() => window.open(process.env.MONUS_WHATSAPP, "_blank")}
    confirmText="Cotizar"
  >
    {children}
  </Confirm>
);

OrderConfirm.propTypes = {
  children: PropTypes.node.isRequired,
  story: PropTypes.shape({
    _id: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
  }).isRequired,
};

export default OrderButton;
